import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { HumanizeDurationPipe } from 'src/app/shared/pipes/humanize-duration.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthorizationsPage } from './authorizations.page';
import { authorizationsRoutes } from './authorizations.routes';
import {
  AuthorizationsFilterComponent,
  NewAuthorizationsComponent,
} from './components/index';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule.forChild(),
    RouterModule.forChild(authorizationsRoutes),
  ],
  declarations: [
    AuthorizationsPage,
    NewAuthorizationsComponent,
    AuthorizationsFilterComponent,
  ],
  providers: [HumanizeDurationPipe],
})
export class AuthorizationsPageModule {}
